<template>
  <div id="paymentPage">
    <transition name="toast">
      <div
        v-if="toast.visible"
        class="toast"
        :class="`toast--${toast.type}`"
        role="alert"
      >
        <span>{{ toast.message }}</span>
        <button type="button" class="toast-close" @click="hideToast">×</button>
      </div>
    </transition>

    <form @submit.prevent="pay">
      <div id="left">
        <img id="mp_logo" src="@/assets/MontyPay.png" alt="MontyPay" />
        <h1 v-if="availableWallets.length">How would you like to pay?</h1>
        <!-- <p>
          Cards and Lebanese wallets are settled to the same merchant account.
        </p> -->
        <div id="payments" v-if="cardsEnabled">
          <h2>Credit & Debit Card</h2>
          <label
            class="option"
            :class="{ selected: selectedPaymentMethod === `hpf` }"
          >
            <input
              type="radio"
              value="hpf"
              v-model="selectedPaymentMethod"
              class="sr-only"
            />
            <div class="row">
              <span class="dot"></span>
              <h2>Pay with card</h2>
            </div>
            <div id="hpf" v-show="selectedPaymentMethod === 'hpf'">
              <div class="field">
                <label>Card Number</label>
                <div id="card-container"></div>
              </div>
              <div class="row">
                <div class="field">
                  <label>Expiry</label>
                  <div id="expiry-container"></div>
                </div>
                <div class="field">
                  <label>CVV</label>
                  <div id="cvv-container"></div>
                </div>
              </div>
              <!-- <div class="row">
                <input
                  id="save_card"
                  :checked="save_card"
                  @change="saveCard()"
                  type="checkbox"
                />
                <label for="save_card">Save card information</label>
              </div> -->
            </div>
          </label>
        </div>
        <div
          id="wallets"
          v-if="availableWallets.length"
          :class="`count-${availableWallets.length}`"
        >
          <h2 id="title">Wallets</h2>
          <label
            v-for="wallet in availableWallets"
            :key="wallet.value"
            class="option"
            :class="{ selected: selectedPaymentMethod === wallet.value }"
          >
            <input
              type="radio"
              :value="wallet.value"
              v-model="selectedPaymentMethod"
              class="sr-only"
            />
            <div class="row">
              <span class="dot"></span>
              <div class="info">
                <h2>{{ wallet.label }}</h2>
                <!-- <p>{{ wallet.desc }}</p> -->
              </div>
              <img :src="wallet.img_url" :alt="wallet.label" />
            </div>
          </label>
        </div>
      </div>
      <div id="right">
        <div id="total">
          <div class="row">
            <h2>Total due</h2>
            <h1>{{ formattedAmount }}</h1>
          </div>
          <button id="final-pay" type="submit" :disabled="loading">
            <template v-if="loading">
              <span class="spinner"></span>
              Processing
            </template>
            <template v-else> Pay {{ formattedAmount }} </template>
          </button>
          <div id="disclaimer">
            <!-- <div class="row">
              <svg
                data-dc-tpl="80"
                width="13"
                height="13"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#5C584F"
                stroke-width="1.9"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <rect
                  data-dc-tpl="81"
                  x="4"
                  y="10"
                  width="16"
                  height="11"
                  rx="2.5"
                ></rect>
                <path data-dc-tpl="82" d="M8 10V7a4 4 0 0 1 8 0v3"></path>
              </svg>
              <p>Secured by</p>
              <img src="@/assets/MontyPay.png" alt="MontyPay" />
            </div> -->
            <div class="row">
              <img src="@/assets/pcidss.png" alt="PCI-DSS" />
            </div>
          </div>
        </div>
        <div id="reason" v-show="reason">{{ reason }}</div>
      </div>
    </form>
  </div>
</template>

<script>
import axios from "axios";

const CURRENCIES_3_DECIMALS = ["JOD", "BHD", "KWD", "OMR", "TND"];

// Must stay identical to formatAmount() in src/index.js: order.amount feeds the session hash.
function formatAmount(amount, currency) {
  const value = typeof amount === "string" ? parseFloat(amount) : amount;
  const decimals = CURRENCIES_3_DECIMALS.includes(currency) ? 3 : 2;
  return Number(value || 0).toFixed(decimals);
}

// const freshFieldState = () => ({
//   card: { invalid: false, focused: false },
//   expiry: { invalid: false, focused: false },
//   cvv: { invalid: false, focused: false },
// });

export default {
  name: "PaymentPage",
  data() {
    return {
      shop: "",
      domain: "",
      config: {},
      // wallet_config: {},
      paymentSession: {},
      payment_session_id: "",
      cardholder_name: "",
      token: "",
      hpf_ready: false,
      error_message: "",
      loading: false,
      hostedFields: null,
      checkoutHost: "YOUR_CHECKOUT_HOST",
      sessionToken: "YOUR_SESSION_TOKEN",
      returnUrl: "", // our /return_page; set in getToken()
      toast: { visible: false, message: "", type: "error" },
      toastTimer: null,
      selectedPaymentMethod: "",
      wallets: [
        {
          value: "My_MONTY",
          img_url: require("@/assets/mymonty.svg"),
          label: "MyMonty",
          desc: "Pay from your MyMonty balance",
        },
        {
          value: "WHISH",
          img_url: require("@/assets/whish.png"),
          label: "WHISH Pay",
          desc: "Approve in the Whish app",
        },
        {
          value: "OMT",
          img_url: require("@/assets/omtpay.png"),
          label: "OMT Pay",
          desc: "Redirects to OMT Pay",
        },
      ],
      reason: "",
      serverURL: "https://montypaylive.fly.dev",
      // save_card: false,
      // customerData: [],
    };
  },
  computed: {
    formattedAmount() {
      const ps = this.paymentSession;
      if (!ps?.currency) return "";
      return `${formatAmount(ps.amount, ps.currency)} ${ps.currency}`;
    },
    // Chosen on the config page; the DB defaults it to "cards_only"
    paymentOption() {
      return this.config?.payment_option || "cards_only";
    },
    cardsEnabled() {
      return ["cards_only", "cards_and_wallets"].includes(this.paymentOption);
    },
    walletsEnabled() {
      return ["wallets_only", "cards_and_wallets"].includes(this.paymentOption);
    },
    availableWallets() {
      if (!this.walletsEnabled) return [];
      const brands = this.config?.wallet_brands;

      const enabled = Array.isArray(brands) ? brands : [];
      return this.wallets.filter((wallet) => enabled.includes(wallet.value));
    },
  },
  methods: {
    async getData() {
      // const shop = this.shop || this.domain;

      // console.log("Current URL:", currentUrl);

      /**Payment Sesseion */
      try {
        const resp = await axios.get(
          `/paymentSession/get?paymentSession=${this.payment_session_id}`,
        );
        // console.log("Payment Session:", resp.data);
        this.paymentSession = resp.data;
      } catch (err) {
        console.error(
          "Error in getting Payment Session:",
          err.response?.data || err.message,
        );
        this.showToast("Payment Session Not Found", "error");
      }

      /**Configuration */
      try {
        const resp = await axios.get(`/configuration/get?shop=${this.shop}`);
        // console.log("Config:", resp.data);
        this.config = resp.data;
      } catch (err) {
        console.error(
          "Error in getting Config:",
          err.response?.data || err.message,
        );
        this.showToast("Configuration Not Found", "error");
      }

      // /**Wallet Configuration */
      // try {
      //   const resp = await axios.get(
      //     `/wallet/configuration/brands?shop=${this.shop}`,
      //   );
      //   // console.log("Wallet Brands:", resp.data);
      //   this.wallet_config = resp.data;
      // } catch (err) {
      //   console.error(
      //     "Error in getting Wallet Brands:",
      //     err.response?.data || err.message,
      //   );
      //   this.showToast("Wallet Brands Not Found", "error");
      // }

      /**Customer Data */
      // try {
      //   console.log(this.paymentSession.customer.email);
      //   console.log(this.shop);
      //   const resp = await axios.get(
      //     `/customerData/get?shop=${this.shop}&email=${this.paymentSession.customer.email}`,
      //   );
      //   console.log("Customer Data:", resp.data);
      //   this.customerData = resp.data;
      // } catch (err) {
      //   console.error(
      //     "Error in getting Config:",
      //     err.response?.data || err.message,
      //   );
      //   this.showToast("Customer Data Not Found", "error");
      // }
    },
    async getToken() {
      // payment page URL with the error added (replaces any old ?error=)
      const pageUrlWith = (error) => {
        const url = new URL(window.location.href);
        url.searchParams.set("error", error);
        return url.toString();
      };

      const returnUrl = new URL(`${this.serverURL}/return_page`);
      returnUrl.searchParams.set("order_id", this.paymentSession.id);
      returnUrl.searchParams.set("save_card", this.save_card);
      returnUrl.searchParams.set("failed_url", pageUrlWith("Payment Failed"));
      this.returnUrl = returnUrl.toString();

      try {
        const resp = await axios.post(`/hpf/tokengeneration`, {
          merchant_key: this.config.merchantKey,
          merchant_password: this.config.merchantPassword,
          return_url: this.returnUrl,
          save_card: this.saveCard,
          order: {
            number: this.paymentSession.id,
            amount: formatAmount(
              this.paymentSession.amount,
              this.paymentSession.currency,
            ),
            currency: this.paymentSession.currency,
            description: `A payment from ${this.paymentSession.customer.billing_address.given_name} ${this.paymentSession.customer.billing_address.family_name}`,
          },
          checkoutHost: this.config.checkout_url,
          customer: {
            name: `${this.paymentSession.customer.billing_address.given_name} ${this.paymentSession.customer.billing_address.family_name}`,
            email: this.paymentSession.customer.email,
          },
        });
        // console.log("Token:", resp.data);
        this.sessionToken = resp.data.token;
      } catch (err) {
        console.error(
          "Error in getting Config:",
          err.response?.data || err.message,
        );
        throw new Error("Merchant configuration not found.");
      }
    },
    loadHostedFields() {
      return new Promise((resolve, reject) => {
        // Load the SDK
        const script = document.createElement("script");
        script.src = `https://${this.checkoutHost}/sdk/hosted-fields.js`;

        script.onload = () => {
          try {
            const config = {
              sessionToken: this.sessionToken,

              fields: {
                card: {
                  id: "card-container",
                  placeholder: "0000 0000 0000 0000",
                  style: {
                    input: {
                      // color: "red",
                      margin: "0",
                      height: "100%",
                      width: "100%",
                      padding: "0",
                      background: "transparent",
                    },
                    "::placeholder": {
                      // "font-size": "1rem",
                      // color: "blue",
                    },
                    ".hosted-field-card-brand-logo": {
                      border: "1px solid silver",
                    },
                  },
                },

                expiry: {
                  id: "expiry-container",
                  placeholder: "MM / YY",
                  style: {
                    input: {
                      // color: "red",
                      margin: "0",
                      height: "100%",
                      width: "100%",
                      padding: "0",
                      background: "transparent",
                    },
                  },
                },

                cvv: {
                  id: "cvv-container",
                  placeholder: "123",
                  style: {
                    input: {
                      // color: "red",
                      margin: "0",
                      height: "100%",
                      width: "100%",
                      padding: "0",
                      background: "transparent",
                    },
                  },
                },
              },

              style: {
                input: {
                  "font-size": "1rem",
                },
                "::placeholder": {
                  "font-size": "1rem",
                  color: "#777",
                  "font-style": "italic",
                },
              },
            };

            this.hostedFields = new window.HostedFields();
            this.hostedFields.init(config);

            resolve();
          } catch (error) {
            reject(error);
          }
        };

        script.onerror = () => {
          reject(new Error("Failed to load Hosted Fields SDK"));
        };

        document.head.appendChild(script);
      });
    },
    async handleHostedFieldsMessage(event) {
      // Ignore messages that aren't from the Hosted Fields iframe
      if (event.origin !== `https://${this.checkoutHost}`) {
        return;
      }

      // Ignore unrelated messages
      if (!event.data || event.data.type !== "FIELDS_SUBMITTED") {
        return;
      }

      // console.log("Hosted Fields submitted");
      // console.log("Hosted Fields data:", event.data.data);

      const fieldsData = event.data.data;
      // Continue with your payment request here
      if (fieldsData.result === "success") {
        try {
          const resp = await axios.post(`/hpf/purchase`, {
            name: `${this.paymentSession.customer.billing_address.given_name} ${this.paymentSession.customer.billing_address.family_name}`,
            email: this.paymentSession.customer.email,
            checkoutHost: this.config.checkout_url,
            token: this.sessionToken,
            billing_address: this.billingAddress(),
            browser_info: this.browserInfo(), // 3DS data; MPGS requires it
          });
          // console.log("Responce:", resp.data);
          if (resp.data.result === "redirect") {
            const redirectUrl = resp.data.redirect_url;
            const redirectParams = resp.data.redirect_params;

            // =========================
            // POST REDIRECT
            // =========================
            if (redirectParams) {
              const form = document.createElement("form");

              form.method = "POST";
              form.action = redirectUrl;
              form.style.display = "none";

              Object.entries(redirectParams).forEach(([key, value]) => {
                const input = document.createElement("input");

                input.type = "hidden";
                input.name = key;
                input.value = value;

                form.appendChild(input);
              });

              document.body.appendChild(form);

              // console.log("POST redirect:", redirectUrl);
              // console.log("POST parameters:", redirectParams);

              form.submit();

              return;
            }

            // =========================
            // GET REDIRECT
            // =========================
            const params = new URLSearchParams(
              resp.data.return_url_query_params || {},
            );

            const url = `${redirectUrl}?${params.toString()}`;

            console.log("GET redirect:", url);

            window.location.href = url;
          } else if (resp.data.result === "success") {
            // No 3DS: already charged and MontyPay sends no redirect_url. Go to the
            // return page 3DS ends on; it checks the status, resolves the Shopify
            // session and redirects to the order confirmation page.
            window.location.href = this.returnUrl;
          } else {
            this.error_message = "Payment Failed";
            this.showReason(resp.data.decline_message || "");
          }
        } catch (err) {
          const data = err.response?.data;
          console.error("Card payment failed:", data || err.message);
          this.error_message = "Payment Failed";
          this.showReason(this.gatewayErrorMessage(data));
        }
      } else {
        this.error_message = fieldsData.message;
      }
    },
    billingAddress() {
      const b = this.paymentSession?.customer?.billing_address;
      if (!b) return undefined;
      const out = {
        country: b.country_code,
        state: b.province,
        city: b.city,
        address: [b.line1, b.line2].filter(Boolean).join(", "),
        zip: b.postal_code,
        phone: b.phone_number,
      };
      for (const key of Object.keys(out)) if (!out[key]) delete out[key];
      return Object.keys(out).length ? out : undefined;
    },
    browserInfo() {
      // Shape documented by MontyPay for 3DS; every value is a string.
      return {
        color_depth: String(window.screen.colorDepth),
        java_enabled: String(
          typeof navigator.javaEnabled === "function" &&
            navigator.javaEnabled(),
        ),
        java_script_enabled: "true",
        language: navigator.language,
        screen_height: String(window.screen.height),
        screen_width: String(window.screen.width),
        time_zone_offset: String(new Date().getTimezoneOffset()),
        user_agent: navigator.userAgent,
        platform: navigator.platform,
      };
    },
    gatewayErrorMessage(data) {
      const e = data?.error;
      return (
        e?.errors?.[0]?.error_message ||
        e?.error_message ||
        e?.message ||
        data?.decline_message ||
        "Payment Failed"
      );
    },
    async pay() {
      if (this.loading) return;
      this.error_message = "";
      this.loading = true;

      switch (this.selectedPaymentMethod) {
        case "hpf":
          return this.payWithCard();
        case "WHISH":
          return this.payWithWhish();
        case "My_MONTY":
          return this.payWithMyMonty();
        case "OMT":
          return this.payWithOmt();
        default:
          this.showToast("Please choose a payment method.", "alert");
      }
    },
    payWithCard() {
      console.log("Collecting card details...");
      this.hostedFields.collectIframesData(); // result handled in handleHostedFieldsMessage
    },
    async payWithMyMonty() {
      // TODO: call the MyMonty payment endpoint
      const pageUrlWith = (error) => {
        const url = new URL(window.location.href);
        url.searchParams.set("error", error);
        return url.toString();
      };
      await axios
        .post("/wallet/payment", {
          brand: this.selectedPaymentMethod,
          paymentSession: this.paymentSession,
          cancel_url: pageUrlWith("Payment Failed"),
        })
        .then((response) => {
          // console.log("Response:", response.data);
          window.location.href = response.data.data.url;
        })
        .catch((error) => {
          console.log("Error:", error);
          this.showToast("Payment Failed", "error");
          this.showReason(error.response.data.message);
        });
    },
    async payWithWhish() {
      // TODO: call the Whish payment endpoint
      // TODO: call the MyMonty payment endpoint
      const pageUrlWith = (error) => {
        const url = new URL(window.location.href);
        url.searchParams.set("error", error);
        return url.toString();
      };
      await axios
        .post("/wallet/payment", {
          brand: this.selectedPaymentMethod,
          paymentSession: this.paymentSession,
          cancel_url: pageUrlWith("Payment Failed"),
        })
        .then((response) => {
          // console.log("Response:", response.data);
          window.location.href = response.data.data.url;
        })
        .catch((error) => {
          console.log("Error:", error);
          this.showToast("Payment Failed", "error");
          this.showReason(error.response.data.message);
        });
    },
    async payWithOmt() {
      // TODO: call the MyMonty payment endpoint
      const pageUrlWith = (error) => {
        const url = new URL(window.location.href);
        url.searchParams.set("error", error);
        return url.toString();
      };
      await axios
        .post("/wallet/payment", {
          brand: this.selectedPaymentMethod,
          paymentSession: this.paymentSession,
          cancel_url: pageUrlWith("Payment Failed"),
        })
        .then((response) => {
          // console.log("Response:", response.data);
          window.location.href = response.data.data.url;
        })
        .catch((error) => {
          console.log("Error:", error);
          this.showToast("Payment Failed", "error");
          this.showReason(error.response.data.message);
        });
    },
    showToast(message, type = "error") {
      clearTimeout(this.toastTimer);
      if (type !== "success") this.loading = false; // payment stopped, let the user try again
      this.toast = { visible: true, message, type };
      this.toastTimer = setTimeout(this.hideToast, 4000);
    },
    hideToast() {
      clearTimeout(this.toastTimer);
      this.toast.visible = false;
      this.error_message = "";
    },
    showReason(message) {
      // payment stopped, let the user try again
      this.reason = message;
    },
    saveCard() {
      this.save_card = !this.save_card;
      console.log("Checked:", this.save_card);
    },
  },
  async mounted() {
    const query = this.$route.query;
    this.shop = query.shop || "";
    this.domain = query.domain || "";
    this.payment_session_id = query.payment_session_id || "";
    this.error_message = query.error || "";
    this.reason = query.reason || "";

    if (!this.payment_session_id || !(this.shop || this.domain)) {
      this.error_message = "Invalid payment link.";
      return;
    }
    // if (this.reason) {
    //   return;
    // }

    try {
      await this.getData();
      this.checkoutHost = this.config.checkout_url;

      // Default to the card; this triggers the watcher, which loads the card fields
      if (this.cardsEnabled && this.config?.checkout_url) {
        this.selectedPaymentMethod = "hpf";
      } else if (!this.cardsEnabled && this.availableWallets.length === 1) {
        this.selectedPaymentMethod = this.availableWallets[0].value; // only choice
      } else if (!this.cardsEnabled && !this.availableWallets.length) {
        this.error_message = "No payment method is available for this store.";
      }
    } catch (err) {
      this.error_message =
        err.message || "Could not initialise the payment form.";
    }
  },
  watch: {
    async selectedPaymentMethod(newValue) {
      if (newValue !== "hpf" || this.hostedFields) return; // already set up

      try {
        await this.getToken();
        this.checkoutHost = this.config.checkout_url;

        await this.$nextTick(); // wait for Vue to update the page
        await this.loadHostedFields();
        window.addEventListener("message", this.handleHostedFieldsMessage);
      } catch (err) {
        this.error_message =
          err.message || "Could not initialise the payment form.";
      }
    },
    error_message(msg) {
      if (msg) this.showToast(msg);
    },
    error_reason(msg) {
      if (msg) this.showReason(msg);
    },
  },

  beforeUnmount() {
    window.removeEventListener("message", this.handleHostedFieldsMessage);
    clearTimeout(this.toastTimer);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@use "../styles/brand" as *;
@import url("https://fonts.googleapis.com/css2?family=Manrope:wght@200..800&family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap");

@keyframes pay-spin {
  to {
    transform: rotate(360deg);
  }
}

body {
  margin: 0;
  padding: 0;
}

@mixin main-columns-commons {
  background-color: transparent;
  // width: calc(50% - 4.5rem);
  // margin: 2rem;

  h1,
  p {
    background-color: transparent;
    border: 0;
  }

  h1 {
    font-size: 28px;
  }

  p {
    font-size: 14px;
  }
  @media screen and (max-width: 900px) {
    width: 100%;
  }
}

#paymentPage {
  // height: 100dvh;
  min-height: 100vh;
  width: calc(100dvw - 8px);
  background-color: $bg-primary;
  display: flex;
  justify-content: center;

  * {
    background-color: transparent;
  }
  form {
    display: flex;
    // flex-wrap: wrap;
    min-width: 400px;
    flex-direction: column;
    // justify-content: flex-start;
    // align-items: flex-start;
    gap: 1rem;
    // width: 100%;
    // overflow: hidden;
    background-color: $bg-primary;
    // border-radius: 18px;
    // border: 1.5px solid $primary;

    h2 {
      @include sub-menu();
    }

    #left {
      margin-top: 2rem;
      @include main-columns-commons;

      #mp_logo {
        height: 50px;
      }
      .sr-only {
        position: absolute;
        opacity: 0;
        width: 0;
        height: 0;
      }
      .option {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 10px;
        cursor: pointer;
        background-color: $white;
        border: 1.5px solid $light-gray;
        padding: 1rem;
        border-radius: 18px;

        .row {
          display: flex;
          gap: 1rem;
          align-items: center;
          // width: 100%;
        }
      }
      .option.selected {
        border-color: $primary;
      }
      .dot {
        width: 16px;
        min-width: 16px;
        height: 16px;
        border: 2px solid #999;
        border-radius: 50%;
        transition: all 0.1s ease-in-out;
      }
      .option.selected .dot {
        background-color: $primary;
      }

      #payments {
        .option {
          #hpf {
            width: 100%;
            display: flex;
            flex-direction: column;
            gap: 1rem;

            label {
              font-size: 12.5px;
              font-weight: 600;
              color: $dark-gray;
              margin: 0;
            }

            .field {
              width: 100%;

              #card-container {
                @include field-commons();
                width: calc(100% - 28px);
              }
            }

            .row {
              width: 100%;
              display: flex;
              gap: 1rem;
              padding: 0;

              .field {
                // width: 50%;
                #expiry-container {
                  @include field-commons();
                  // width: 50%;
                }
                #cvv-container {
                  @include field-commons();
                  // width: 50%;
                }
              }

              #save_card {
                background-color: $primary;
                border-radius: 50%;

                &:checked::before {
                  background: $bg-primary;
                }
              }
            }
          }
        }
      }

      #wallets {
        display: flex;
        flex-wrap: wrap;
        gap: 1rem;

        #title {
          @include sub-menu();
          width: 100%;
        }

        .option {
          width: calc(100% / 3 - 3rem);
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          height: 100px;
          border: 1px solid $light-gray;

          .row {
            display: flex;
            flex-direction: row-reverse;
            justify-content: space-between;
            align-items: center;
            width: 100%;

            img {
              // width: auto;
              height: 60px;
              aspect-ratio: 1;
              object-fit: contain;
              margin: 0;
            }
            .info {
              display: flex;
              flex-direction: column;
              gap: 0.5rem;
              h2 {
                margin: 0;
                font-size: 16px;
                text-transform: none;
              }
              p {
                margin: 0;
              }
            }
          }
        }
        .option.selected {
          border-color: $primary;
        }
        // Tile width follows how many wallets are enabled (3 uses .option above)
        &.count-1 .option {
          width: 100%;
          box-sizing: border-box; // keep padding + border inside the 100%
        }
        &.count-2 .option {
          width: calc(100% / 2 - 3rem);
        }
      }
    }
    #right {
      @include main-columns-commons;

      #total {
        background-color: $white;
        border-radius: 22px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 26px 26px 22px;
        gap: 18px;
        border: 1px solid $light-gray;

        .row {
          display: flex;
          justify-content: space-between;
          align-items: flex-end;
          width: 100%;
          h1,
          h2 {
            margin: 0;
          }
        }
        #final-pay {
          background-color: $primary;
          width: 100%;
          color: $white;
          height: 56px;
          font-size: 16px;
          font-weight: 600;
          letter-spacing: -0.01em;
          border-radius: 16px;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 10px;

          &:disabled {
            opacity: 0.8;
            cursor: progress;
          }

          .spinner {
            width: 18px;
            height: 18px;
            border: 2.5px solid rgba(255, 255, 255, 0.35);
            border-top-color: $white;
            border-radius: 50%;
            animation: pay-spin 0.8s linear infinite;
          }
        }
        #disclaimer {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          width: 100%;
          gap: 9px;

          .row {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 9px;

            p {
              font-size: 11px;
              color: $dark-gray;
              margin: 0;
            }
            img {
              width: 60px;
              // height: 20px;
              margin: 0;
            }

            #pcidss {
              background-color: $primary;
              padding: 0.25rem;
              border-radius: 16px;
            }
          }
        }
      }
      #reason {
        background-color: $error;
        color: $errorText;
        padding: 1rem;
        margin-top: 2rem;
        border-radius: 18px;
        border: 1px solid $errorText;
        font-size: 14.5px;
      }
    }
  }

  .toast {
    position: fixed;
    top: 20px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 1000;
    display: flex;
    align-items: center;
    gap: 12px;
    max-width: calc(100% - 32px);
    padding: 12px 16px;
    border-radius: 12px;
    // background-color: $error;
    // color: $white;
    font-size: 14px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);

    &--success {
      background-color: $success;
      color: $successText;
      span {
        color: $successText;
        font-weight: bold;
      }
    }
    &--alert {
      background-color: $alert;
      color: $alertText; // dark text: white on yellow is hard to read
      span {
        color: $alertText;
        font-weight: bold;
      }
    }
    &--error {
      background-color: $error;
      color: $errorText;

      span {
        color: $errorText;
        font-weight: bold;
      }
    }

    .toast-close {
      background: transparent;
      border: 0;
      color: inherit; // follows each type's text color
      font-size: 18px;
      line-height: 1;
      cursor: pointer;
    }
  }

  .toast-enter-active,
  .toast-leave-active {
    transition: opacity 0.25s ease, transform 0.25s ease;
  }
  .toast-enter-from,
  .toast-leave-to {
    opacity: 0;
    transform: translate(-50%, -12px);
  }
}
@media screen and (max-width: 450px) {
  #paymentPage {
    form {
      #left {
        margin-bottom: 0;
        #wallets {
          gap: 0.25rem;
          .option,
          &.count-2 .option {
            width: 100%;
            box-sizing: border-box; // keep padding + border inside the 100%
            height: 80px;
          }
        }
      }

      #right {
        margin-top: 0;

        #total {
          .row {
            h1 {
              font-size: 20px;
            }
          }
        }
      }
    }
  }
}
</style>
